export const SERVER_ERROR = "server_error";
export const UNAUTHORIZED_ERROR = "unauthorized_error";
export const EXPIRED_SESSION_ERROR = "expired_session_error";